import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { Application } from '../../models/application.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class ApplicationService {
  applications: Application[];
  applicationEditing: Application;
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private messageService: MessageService
  ) {
    this.applications = [];
  }

  getAll() {
    return this.h.get('/koncentro-auth/applications')
      .map(res => {
        return this.applications = res;
      });
  }

  getUserForApp(app_id: number, limit?: number) {
    return this.h.get('/koncentro-auth/applications/users/' + app_id + '?limit=' + limit);
  }

  delete(record) {
    return this.h.delete('/koncentro-auth/applications/' + record.id)
      .map(res => {
        this.applications.splice(this.applications.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Applications deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-auth/applications/', newData)
      .map(res => {
        newData.id = res.id;
        // this.applications.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  put(newData) {
    return this.h.put('/koncentro-auth/applications/', newData)
      .map(res => {
        // Object.assign(this.applicationEditing, newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-auth/schema/ApplicationDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/application/applications.service.ts